import $ from 'jquery';
import 'owl.carousel';

export default () => {
    let isRtl = $("html").attr("dir") === "rtl";

$('.boxes-carousel').owlCarousel({
    rtl: isRtl,
    center: true,
    loop: true,
    margin: 10,
    responsive: {
        0: {
            items: 1
        },
        768: {
            items: 3
        }
    }
});

$('.impact-carousel').owlCarousel({
    rtl: isRtl,
    autoplay: true,
    center: true,
    loop: true,
    items: 1,
    margin: 10
});

$('.gallery-carousel').owlCarousel({
    rtl: isRtl,
    center: true,
    loop: true,
    margin: 10,
    responsive: {
        0: {
            items: 1
        },
        768: {
            items: 2,
            stagePadding: 80
        }
    }
});
}